import {
	Checkbox,
	FormControl,
	FormControlLabel,
	InputLabel,
	MenuItem,
	Select,
	TextField,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useState } from 'react';
import { CgSpinner } from 'react-icons/cg';

import { MesAno } from '@/utils/MesAno';

import { Button } from './Button';

interface Props {
	title: string;
	mesAno: MesAno;
	setMesAno: (value: MesAno) => void;
	isEverything: boolean;
	setIsEverything: (value: boolean) => void;
	isOpen: boolean;
	setIsOpen: (value: boolean) => void;
	onConfirmation: () => Promise<void>;
}

export const MesAnoDialog = ({
	title,
	mesAno,
	setMesAno,
	isEverything,
	setIsEverything,
	isOpen,
	setIsOpen,
	onConfirmation,
}: Props) => {
	const [loading, setLoading] = useState(false);

	const handleConfirmation = async () => {
		setLoading(true);
		try {
			await onConfirmation();
		} catch (error) {
			console.error('Error during confirmation:', error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<Dialog
			PaperProps={{
				style: {
					borderRadius: '20px',
					boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
					overflowY: 'unset',
					height: '20rem',
					width: '40rem',
				},
			}}
			open={isOpen}
			onClose={() => setIsOpen(false)}
		>
			<div className="flex justify-center border-b-[1px] border-[#7b7b7b42] p-2">
				<DialogTitle>
					<span className="px-1 text-center font-graphie  text-[19px] font-semibold text-slate-800">
						{title}
					</span>
				</DialogTitle>
			</div>
			<DialogContent
				sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
			>
				<FormControlLabel
					control={
						<Checkbox
							checked={isEverything}
							onChange={(e) => setIsEverything(e.target.checked)}
						/>
					}
					label="Tudo"
				/>
				<>
					<FormControl disabled={isEverything}>
						<InputLabel id="month-select-label">Mês</InputLabel>
						<Select
							labelId="month-select-label"
							value={mesAno.month}
							onChange={(e) => {
								setMesAno(new MesAno(Number(e.target.value), mesAno.year));
							}}
							label="Mês"
							sx={{ width: '10rem' }}
						>
							{Array.from({ length: 12 }, (_, i) => (
								<MenuItem key={i + 1} value={i + 1}>
									{new Date(0, i)
										.toLocaleString('pt-BR', { month: 'long' })
										.replace(/^\w/, (c) => c.toUpperCase())}
								</MenuItem>
							))}
						</Select>
					</FormControl>
					<TextField
						label="Ano"
						type="number"
						value={mesAno.year}
						onChange={(e) => {
							setMesAno(new MesAno(mesAno.month, Number(e.target.value)));
						}}
						InputLabelProps={{ shrink: true }}
						inputProps={{ max: 9999, min: 1 }}
						sx={{ marginLeft: 2 }}
						disabled={isEverything}
					/>
				</>
			</DialogContent>{' '}
			<DialogActions
				sx={{
					width: 'full',
					display: 'flex',
					justifyContent: 'space-around',
					paddingBottom: '25px',
				}}
			>
				<Button
					type="button"
					className="min-w-40 border-2 border-[#193CB9] bg-white text-[#193CB9] hover:bg-[#e9eaf1]"
					onClick={() => setIsOpen(false)}
					disabled={loading}
				>
					Cancelar
				</Button>
				<Button
					type="button"
					className={`min-w-40 ${loading ? 'bg-gray-200' : ''} ${!isEverything && (!mesAno.start || !mesAno.end) ? 'bg-gray-200' : ''}`} // Add additional condition for background color if needed
					onClick={handleConfirmation}
					disabled={
						loading || (!isEverything && (!mesAno.start || !mesAno.end))
					}
				>
					{loading ? (
						<CgSpinner
							size={30}
							color="#4f4f4f"
							className="h-full animate-spin"
						/>
					) : (
						'Confirmar'
					)}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
